{
  "ancillaries": {
    "productCard": {
      "button": {
        "added": "Lisätty ({numberOfItems})"
      }
    }
  }
}
